import React from 'react';
const LoadingPage = () => {
     return (
         <>
        <section className ="loading-container">
            <div className="loading">
        <h1>Loading...</h1>
        </div>
        </section>
         </>
     )
}
export default LoadingPage